import { ERROR_HOME } from './messages'
import { LOAD_AVAILABLEDATES, LOAD_PAYMENT, LOAD_CHECK } from './settings'

const initState = {
  values: {
    travel: 0,
    origin: undefined,
    destiny: undefined,
    nAdults: 0,
    nTeens: 0,
    nKids: 0,
    nBabies: 0,
    nPets: 0,
    bFamily: false,
    bCouple: false,
    nCars: 0,
    nMotorcycles: 0,
    nVans: 0,
    nTowing: 0,
    nBikes: 0,
    //data of Router Search
    departuretravel: undefined,
    returntravel: undefined,
    //data of Router data
    isPassager1: false,
  },
  contact: {
    secondSurname: '',
  },
  
  baby1: {
    locationReturn: 0,
    locationGone: 0,
  },
  errors: {},
}

//Definicion de constantes
const UPDATE_DATA = 'DATA_UPDATE_DATA'
const UPDATE_VALUES = 'DATA_UPDATE_VALUES'

//Definicion de acciones
export const updateData = (val) => ({type: UPDATE_DATA, payload: val})
export const updateValues = (val) => ({type: UPDATE_VALUES, payload: val})

export default (state = initState, action) => {
  switch (action.type){
    case LOAD_AVAILABLEDATES:
      return {...state, values: {...state.values, departuredate: undefined, returndate: undefined}}
    case UPDATE_DATA:
      return {...state, ...action.payload}
    case UPDATE_VALUES:
      return {...state, values: {...state.values, ...action.payload}}
    case LOAD_PAYMENT:
        return {...state, payment: action.payload}
    case LOAD_CHECK:
        return {...state, ...action.payload}
    case ERROR_HOME:
      return initState
		default:
			return state
	}
}



// WEBPACK FOOTER //
// ./src/shared/routers/data.js